module.exports = __webpack_public_path__ + "img/kalendarium2.e63b189e.png";